enum EmptyInfoModalEnum {
	CONTACT = 'contact',
	BANK = 'bank',
	CONTACT_AND_BANK = 'contactAndBank',
	INVALID_EMAIL = 'invalidEmail',
}

type EmptyInfoModalProps = {
	open: boolean;
	variant: EmptyInfoModalEnum;
};

export type {EmptyInfoModalProps};

export {EmptyInfoModalEnum};
